import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot } from '@angular/router';
import { Store, select } from '@ngrx/store';
import { iif, of, race, timer } from 'rxjs';
import { map, take } from 'rxjs/operators';

import { getUserAuthorized } from 'ish-core/store/customer/user';
import { CookiesService } from 'ish-core/utils/cookies/cookies.service';
import { whenTruthy } from 'ish-core/utils/operators';

/**
 * Presidio — unauthenticated access redirects to the full Sign-in page.
 * Adds forcePageView so stock login.guard (if used) cannot open the modal.
 */
export function authGuard(snapshot: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
  const store = inject(Store);
  const router = inject(Router);
  const cookieService = inject(CookiesService);

  const defaultRedirect = router.createUrlTree(['/login'], {
    queryParams: {
      ...snapshot.data?.queryParams,
      ...snapshot.queryParams,
      returnUrl: state.url,
      forcePageView: true,
    },
  });

  return iif(
    () => SSR,
    of(defaultRedirect),
    race(
      store.pipe(select(getUserAuthorized), whenTruthy(), take(1)),
      timer(!router.navigated && cookieService.get('apiToken') ? 4000 : 0).pipe(map(() => defaultRedirect))
    )
  );
}
